"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TranscodingState = require("./TranscodingState");
Object.keys(_TranscodingState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranscodingState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TranscodingState[key];
    }
  });
});